var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 53,
    viewBox: "0 0 40 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 52.5C20.3118 52.5 20.6356 52.3634 20.9314 52.1941C21.2415 52.0166 21.5862 51.7643 21.9557 51.4548C22.696 50.8347 23.5787 49.9483 24.5442 48.8658C26.4775 46.6985 28.7777 43.7062 30.9852 40.3853C33.1926 37.0643 35.3154 33.4027 36.8882 29.8956C38.4557 26.4006 39.5 23.0094 39.5 20.2453C39.5 9.34633 30.7756 0.5 20 0.5C9.22442 0.5 0.5 9.34633 0.5 20.2453C0.5 23.0094 1.54429 26.4006 3.11175 29.8956C4.68461 33.4027 6.80742 37.0643 9.01485 40.3853C11.2223 43.7062 13.5225 46.6985 15.4558 48.8658C16.4213 49.9483 17.304 50.8347 18.0443 51.4548C18.4138 51.7643 18.7585 52.0166 19.0686 52.1941C19.3644 52.3634 19.6882 52.5 20 52.5Z",
    fill: "#D34141",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 11,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0417 21.1667H21.5808L21.4175 21.0092C21.9892 20.3442 22.3333 19.4808 22.3333 18.5417C22.3333 16.4475 20.6358 14.75 18.5417 14.75C16.4475 14.75 14.75 16.4475 14.75 18.5417C14.75 20.6358 16.4475 22.3333 18.5417 22.3333C19.4808 22.3333 20.3442 21.9892 21.0092 21.4175L21.1667 21.5808V22.0417L24.0833 24.9525L24.9525 24.0833L22.0417 21.1667ZM18.5417 21.1667C17.0892 21.1667 15.9167 19.9942 15.9167 18.5417C15.9167 17.0892 17.0892 15.9167 18.5417 15.9167C19.9942 15.9167 21.1667 17.0892 21.1667 18.5417C21.1667 19.9942 19.9942 21.1667 18.5417 21.1667Z",
    fill: "#D34141"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAddress);
export default __webpack_public_path__ + "static/media/searchAddress.91481c75fa7b686ed5e15f0acda8d9cc.svg";
export { ForwardRef as ReactComponent };